"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadModule = void 0;
const react_1 = require("react");
const React = require("react");
const patient_waiver_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/patient-waiver");
const warning_label_1 = require("client/modules/orders/modules/orders-detail/components/order-claims/warning-label");
const store_1 = require("client/modules/orders/store");
class PadModule extends react_1.Component {
    async componentDidMount() {
        var order_id = this.props.params[0];
        var claim_id = Number(this.props.params[1]);
        // var response = await padsStore.getPadDocuments(claim_id, 'claim');
        store_1.ordersStore.readClaim(claim_id);
    }
    render() {
        var order_id = this.props.params[0];
        var claim_id = this.props.params[1];
        return (React.createElement("div", { className: "print-labels__labels" },
            React.createElement(patient_waiver_1.PatientWaiver, null),
            React.createElement("hr", null),
            React.createElement(warning_label_1.WarningLabel, null)));
    }
}
exports.PadModule = PadModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/pads/modules/mobile-pad/mobile-pad.tsx
// module id = 3795
// module chunks = 0